import state from "./state";

export default {
  changeMinivariantStatus() {
    state.minivariant = !state.minivariant;
  },

  setMinivariant({ commit }, value) {
    commit("SET_MINIVARIANT", value);
  },
};
